export const EVENT_TYPE_TEMPLATES = [
  { label: "Réunion d'équipe", description: 'Réunion interne avec les collaborateurs' },
  { label: 'Formation', description: 'Session de formation professionnelle' },
  { label: 'Conférence', description: 'Conférence ou présentation publique' },
  { label: 'Atelier', description: 'Atelier pratique ou workshop' },
  { label: 'Événement privé', description: 'Événement privé sur mesure' },
  { label: 'Séminaire', description: "Séminaire d'entreprise" },
];
